<template>
  <div class="finance-print-table">
    <table class="print-table">
      <thead>
        <tr>
          <th v-for="col in columns" :key="col.column">{{ col.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, idx) in rows" :key="idx">
          <td>{{ idx + 1 }}</td>
          <td>{{ moment(row.date).format("DD-MM-YYYY") || "N/A" }}</td>
          <td>{{ formatNumber(row.gross_income) }}</td>
          <td>{{ formatNumber(row.total_discount) }}</td>
          <td>
            {{
              row.today_receivables ? formatNumber(row.today_receivables) : "0"
            }}
          </td>
          <td>{{ formatNumber(row.net_total) }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="2"><strong>Total</strong></td>
          <td>
            <strong>{{ formatNumber(totalGross) }}</strong>
          </td>
          <td>
            <strong>{{ formatNumber(totalDiscount) }}</strong>
          </td>
          <td>
            <strong>{{
              totalReceivables ? formatNumber(totalReceivables) : "0"
            }}</strong>
          </td>
          <td>
            <strong>{{ formatNumber(sum) }}</strong>
          </td>
        </tr>
      </tfoot>
    </table>
    <div class="print-totals">
      <div><strong>Net Total:</strong> PKR {{ formatNumber(sum) }}</div>
      <div v-if="mediTotal !== null">
        <strong>Medi Rad Total:</strong> PKR {{ formatNumber(mediTotal) }}
      </div>
      <div v-if="organizationTotal !== null">
        <strong>Organization Total:</strong> PKR
        {{ formatNumber(organizationTotal) }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "FinancePrintTable",
  props: {
    columns: Array,
    rows: Array,
    sum: [String, Number],
    mediTotal: [String, Number],
    organizationTotal: [String, Number],
    formatNumber: Function
  },
  methods: {
    moment
  },
  computed: {
    totalGross() {
      return this.rows.reduce(
        (acc, row) => acc + Number(row.gross_income || 0),
        0
      );
    },
    totalDiscount() {
      return this.rows.reduce(
        (acc, row) => acc + Number(row.total_discount || 0),
        0
      );
    },
    totalReceivables() {
      return this.rows.reduce(
        (acc, row) => acc + Number(row.today_receivables || 0),
        0
      );
    }
  }
};
</script>

<style scoped>
.finance-print-table {
  margin-top: 1rem;
}

.print-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11pt;
  margin-bottom: 1rem;
}

.print-table th,
.print-table td {
  border: 1px solid #333;
  padding: 6px 8px;
  text-align: center;
}

.print-table th {
  background: #f5f5f5;
}

.print-totals {
  margin-top: 1rem;
  font-size: 12pt;
  text-align: right;
}
</style>
